export const validateCategoryName = (name: string): string | null => {
  if (!name.trim()) {
    return 'Имя не может быть пустым';
  }
  
  if (name.length > 50) {
    return 'Имя списка должно содержать от 1 до 50 символов';
  }
  
  if (!/^[a-zA-Zа-яА-Я0-9 \-]+$/.test(name)) {
    return 'Имя списка может содержать только буквы, пробелы, цифры и дефис';
  }
  
  return null;
}; 